import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-progress-bar',
  templateUrl: './form-progress-bar.component.html',
  styleUrls: ['./form-progress-bar.component.scss'],
})

/**
 * This components enables a bar for forms. The parent component must send all the steps to this component, and the current step.
 */
export class FormProgressBarComponent  implements OnInit {

  /**
   * Input variables
   */
  @Input() progressBarItems: string[] = [];
  @Input() selectedProgressBarItem: string = "";
  @Input() selectedProgressBarIndex: number = 0;

  /**
   * Variables
   */
  progressPercentage = "0";
  progress = document.getElementsByClassName("progress");
  progressSteps = document.getElementsByClassName("barItem");

  constructor(private cdr: ChangeDetectorRef,
    private translateService: TranslateService,) { }

  // #region --> LifeCycle ---------------------------------------------------

  ngOnInit() {

  }

  // Every time the index changes, the percentage of progress is recalculated.
  ngOnChanges(changes: SimpleChanges){
    if(changes.selectedProgressBarIndex.currentValue!==changes.selectedProgressBarIndex.previousValue){
      this.progressPercentage=(((this.selectedProgressBarIndex)/(this.progressBarItems.length-1))*100).toString();
      this.cdr.detectChanges();
    }
  }

  // #endregion --> LifeCycle ---------------------------------------------------

}
